import { performBulkActionForTopics } from '../../utils'
// eslint-disable-next-line import/no-internal-modules
import { BulkActionComponentProps } from '@insided/deprecated-control/overview'
// eslint-disable-next-line import/no-internal-modules
import ButtonControl from '@insided/deprecated-preact-components/button-control'
// eslint-disable-next-line import/no-internal-modules
import Icon from '@insided/deprecated-preact-components/assets'

const CloseTopic = ({ performBulkAction }: BulkActionComponentProps) => (
  <ButtonControl
    title={
      <div>
        <Icon icon='lock' width={16} height={16} />
        Close topic
      </div>
      }
    size='medium'
    newStyle
      // eslint-disable-next-line @gorazdo/preact/prefer-classname
    class='qa-close-topic'
    onClick={() =>
      performBulkAction({
        onClick: async (topics: any) => await performBulkActionForTopics(topics, 'close'),
        successMessage: 'Topic(s) closed'
      })}
  />
)

export default CloseTopic
